import React, { forwardRef, ReactNode, CSSProperties } from 'react';
import { DOMProps } from '@react-types/shared';

import { TestProps } from '../../../internal/types/testTypes';
import { cn } from '../../../lib/css/className/className';
import './Body.css';

const cls = cn('TableBody');

export interface TableBodyProps extends TestProps, DOMProps {
    /**
     * Дочерние элементы
     * @expectedNode `TableRow`
     */
    children?: ReactNode;

    /**
     * Названия классов для элемента
     */
    className?: string;

    /**
     * Инлайновые стили
     */
    style?: CSSProperties;
}

/**
 * Компонент body таблицы
 */
export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(function TableBody(
    { children, className, style, ...props },
    ref,
) {
    return (
        <tbody ref={ref} className={cls('', [className])} style={style} {...props}>
            {children}
        </tbody>
    );
});
